import { IconButton, InputLabel } from "@mui/material";
import Grid from "@mui/material/Grid";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import MDButton from "../../../components/MDButton/index";
import SelectDropDown from "../../../examples/DropDown/index";
import CloseIcon from "@mui/icons-material/Close";
import MDInput from "components/MDInput";
import { useDispatch, useSelector } from "react-redux";
import { setCompanyType } from "layouts/events/Redux/actionCreator";
import { createCompany, createOrganization } from "../Redux/actionCreator";
import { toast } from "react-toastify";

const CreateOrganizationDialog = ({ handleDialogClose }) => {
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    control,
    getValues,
    formState: { errors },
  } = useForm();
  const selectOptions = [
    {
      key: "1",
      value: "1",
    },
  ];
  const { Company_Type_Data } = useSelector((state) => state.events);
  const companyTypeData = Company_Type_Data?.companyTypeInfo;
  const companyTypeOptions = [];

  companyTypeData?.map((ele) => {
    let obj = {
      key: ele._id,
      value: ele.name,
    };

    companyTypeOptions.push(obj);
  });

  const dispatch = useDispatch();
  const onSubmit = (data) => {
    let payload = {
      name: data?.name,
      companyType: data?.companyType,
      companies: "",
    };
    if (data?.name && data?.companyType && data?.companies) {
      dispatch(createOrganization(payload));
      handleDialogClose();
    } else
      toast.error("Please fill all the fields", {
        position: "top-right",
      });
  };
  const handleCompanyTypeChange = (e) => {
    let companyTypeID;
    //Searching for the name in the Users array to find the ID
    companyTypeOptions.map((obj) => {
      if (obj.value == e.target.value) {
        companyTypeID = obj.key;
      }
    });
    setValue("companyType", companyTypeID);
  };

  useEffect(() => {
    dispatch(setCompanyType());
  }, []);
  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <InputLabel fullWidth>Name</InputLabel>
          </Grid>
          <Grid item xs={8}>
            <MDInput
              placeholder=""
              sx={{ width: "100%", marginTop: "0.4rem" }}
              inputProps={{
                style: { fontSize: 15, fontWeight: "bold" },
              }}
              {...register("name")}
            />
          </Grid>
          <Grid item xs={4}>
            <InputLabel fullWidth>Company Type</InputLabel>
          </Grid>
          <Grid item xs={8}>
            <SelectDropDown
              options={companyTypeOptions}
              placeholder="Select"
              name="companyType"
              defaultValue="none"
              control={control}
              getValues={getValues}
              customOnChange={handleCompanyTypeChange}
              // customOnChange={(e) => {
              //   setValue("companyType", e.target.value);
              // }}
            />
          </Grid>
          <Grid item xs={4}>
            <InputLabel fullWidth>Company</InputLabel>
          </Grid>
          <Grid item xs={8}>
            <SelectDropDown
              options={selectOptions}
              placeholder="Select"
              name="companies"
              defaultValue="none"
              control={control}
              getValues={getValues}
              customOnChange={(e) => {
                setValue("companies", e.target.value);
              }}
            />
          </Grid>
        </Grid>
        <MDButton
          variant="contained"
          color="info"
          type="submit"
          sx={{ marginTop: "2rem", marginLeft: "1rem" }}
        >
          Create
        </MDButton>
      </form>
    </div>
  );
};

export default CreateOrganizationDialog;
